/* ───────────────────────────────────────────────────────────────────────────
   THE MEGA NAV, AS A STATE MACHINE.

   "were still having drop down issues the header should only go away if its a
   new header menu or off the entire white spaces theres random dead zones"

   That sentence is the specification, and it is not something :hover can
   express. A CSS hover menu is open exactly while the pointer is inside ONE
   <li>, so every pixel of the bar that is not that <li> closes it: the space
   between two menu items, the run of empty bar between "Collections" and the
   search icon, the strip above the words. Those are the random dead zones.
   Widening the target moved them around, three times, which is the signal
   that the rule was wrong rather than the numbers.

   What he described is a state machine with three transitions:

     POINTER OVER A MENU ITEM   open that one, close whatever was open
     POINTER LEAVES THE HEADER  close, after a short grace
     ANYTHING ELSE              do nothing

   "Anything else" is the whole point. Moving across the empty half of the bar
   is not a decision, so nothing should happen. The panel is a descendant of
   the header, so moving down into it is also nothing.

   THE CSS :hover RULES STAY. This adds a class alongside them rather than
   replacing them, so a browser that never runs this file keeps the hover menu
   it has today, dead zones and all, instead of losing the menu entirely.

   The grace period exists for the diagonal: leaving the bar at the bottom
   corner on the way into the panel can register one frame outside both.
   ─────────────────────────────────────────────────────────────────────────── */
(function () {
  var OPEN = 'bloom-open';
  var GRACE = 140;
  var DESKTOP = '(hover: hover) and (min-width: 60em)';

  var timer = null;

  function list() {
    return document.querySelector('.header__links-list');
  }

  function wrapper() {
    return document.querySelector('.header__outer-wrapper');
  }

  function items() {
    var l = list();
    return l ? l.children : [];
  }

  function close() {
    var all = items();
    for (var i = 0; i < all.length; i++) all[i].classList.remove(OPEN);
  }

  function open(li) {
    window.clearTimeout(timer);
    var all = items();
    for (var i = 0; i < all.length; i++) {
      if (all[i] !== li) all[i].classList.remove(OPEN);
    }
    /* A menu item with no panel is a plain link, and arriving at one is a
       decision to leave the open panel behind. */
    if (li && li.querySelector('.mega-nav')) li.classList.add(OPEN);
  }

  function start() {
    var l = list();
    var w = wrapper();
    if (!l || !w) return;
    if (!window.matchMedia(DESKTOP).matches) return;

    l.addEventListener('pointerover', function (e) {
      if (!e.target || !e.target.closest) return;
      var li = e.target.closest('.header__links-list > li');
      if (li) open(li);
    });

    /* pointerleave counts descendants, and the panel IS a descendant, so this
       does not fire on the way into it. The dim sheet gave up the pointer
       earlier so it cannot hold the menu open over the whole page either. */
    w.addEventListener('pointerleave', function () {
      window.clearTimeout(timer);
      timer = window.setTimeout(close, GRACE);
    });

    w.addEventListener('pointerenter', function () {
      window.clearTimeout(timer);
    });

    /* Going somewhere is the end of choosing where to go. */
    l.addEventListener('click', close);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
